// Per-product brand mark. Uses the official PNG logo from /public/logos/ when
// `product.logo` is set; otherwise falls back to a Lucide icon over the
// product gradient.
import { Sparkles, TrendingUp, Cpu, Building2, Atom } from "lucide-react";

const ICONS = { Sparkles, TrendingUp, Cpu, Building2, Atom };

export default function ProductMark({ product, size = 40, className = "" }) {
  if (product.logo) {
    return (
      <div
        className={`flex items-center justify-center rounded-sm ${className}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        <img
          src={product.logo}
          alt={`${product.name} logo`}
          className="w-full h-full object-contain"
          style={{ filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.15))" }}
        />
      </div>
    );
  }
  const Icon = ICONS[product.icon] || Sparkles;
  return (
    <div
      className={`flex items-center justify-center rounded-sm ${className}`}
      style={{ width: size, height: size, background: product.gradient, color: "white" }}
      aria-hidden="true"
    >
      <Icon className="h-5 w-5" strokeWidth={2.2} />
    </div>
  );
}
